import axios from "axios";
import {
  ADD_DAILY_COMMISSION_FAIL,
  ADD_DAILY_COMMISSION_REQUEST,
  ADD_DAILY_COMMISSION_SUCCESS,
  GET_DAILY_COMMISSIONS_FAIL,
  GET_DAILY_COMMISSIONS_REQUEST,
  GET_DAILY_COMMISSIONS_SUCCESS,
  GET_DAILY_COMMISSION_BY_ID_FAIL,
  GET_DAILY_COMMISSION_BY_ID_REQUEST,
  GET_DAILY_COMMISSION_BY_ID_SUCCESS,
  UPDATE_DAILY_COMMISSION_FAIL,
  UPDATE_DAILY_COMMISSION_REQUEST,
  UPDATE_DAILY_COMMISSION_SUCCESS,
  DELETE_DAILY_COMMISSION_FAIL,
  DELETE_DAILY_COMMISSION_REQUEST,
  DELETE_DAILY_COMMISSION_SUCCESS,
  GET_COMMISSION_SUMMARY_FAIL,
  GET_COMMISSION_SUMMARY_REQUEST,
  GET_COMMISSION_SUMMARY_SUCCESS,
  UPDATE_EVIDENCE_STATUS_REQUEST,
  UPDATE_EVIDENCE_STATUS_SUCCESS,
  UPDATE_EVIDENCE_STATUS_FAIL,
  BULK_UPDATE_EVIDENCE_STATUS_REQUEST,
  BULK_UPDATE_EVIDENCE_STATUS_SUCCESS,
  BULK_UPDATE_EVIDENCE_STATUS_FAIL,
  EXPORT_DAILY_COMMISSIONS_REQUEST,
  EXPORT_DAILY_COMMISSIONS_SUCCESS,
  EXPORT_DAILY_COMMISSIONS_FAIL,
} from "../constants/dailyCommissionConstant.js";

const baseUrl = process.env.REACT_APP_API_URL || "/api";

/**
 * ✅ ADD DAILY COMMISSION (FORMDATA SAFE)
 */
export const addDailyCommission =
  (commissionData) => async (dispatch, getState) => {
    try {
      dispatch({ type: ADD_DAILY_COMMISSION_REQUEST });

      const {
        adminLogin: { userInfo: adminInfo },
      } = getState();

      const isFormData = commissionData instanceof FormData;

      const config = {
        headers: {
          Authorization: `Bearer ${adminInfo.token}`,
          ...(isFormData ? {} : { "Content-Type": "application/json" }),
        },
      };

      const { data } = await axios.post(
        `${baseUrl}/daily-commissions`,
        commissionData,
        config,
      );

      dispatch({
        type: ADD_DAILY_COMMISSION_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: ADD_DAILY_COMMISSION_FAIL,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Failed to add rake",
      });
    }
  };

/**
 * GET DAILY COMMISSIONS
 */
export const getDailyCommissions =
  (filters = {}) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_DAILY_COMMISSIONS_REQUEST });

      const {
        adminLogin: { userInfo: adminInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${adminInfo.token}`,
        },
        params: filters,
      };

      const { data } = await axios.get(`${baseUrl}/daily-commissions`, config);

      dispatch({
        type: GET_DAILY_COMMISSIONS_SUCCESS,
        payload: data.commissions || data,
        pagination: data.pagination || null,
      });
    } catch (error) {
      dispatch({
        type: GET_DAILY_COMMISSIONS_FAIL,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch rake records",
      });
    }
  };

/**
 * GET DAILY COMMISSION BY ID
 */
export const getDailyCommissionByID = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_DAILY_COMMISSION_BY_ID_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const { data } = await axios.get(`${baseUrl}/daily-commissions/${id}`, {
      headers: { Authorization: `Bearer ${adminInfo.token}` },
    });

    dispatch({
      type: GET_DAILY_COMMISSION_BY_ID_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_DAILY_COMMISSION_BY_ID_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch rake record",
    });
  }
};

/**
 * UPDATE DAILY COMMISSION
 */
export const updateDailyCommission =
  (id, updateData) => async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_DAILY_COMMISSION_REQUEST });

      const {
        adminLogin: { userInfo: adminInfo },
      } = getState();

      const { data } = await axios.put(
        `${baseUrl}/daily-commissions/${id}`,
        updateData,
        {
          headers: {
            Authorization: `Bearer ${adminInfo.token}`,
            "Content-Type": "application/json",
          },
        },
      );

      dispatch({
        type: UPDATE_DAILY_COMMISSION_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_DAILY_COMMISSION_FAIL,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Failed to update rake",
      });
    }
  };

/**
 * DELETE DAILY COMMISSION
 */
export const deleteDailyCommission = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: DELETE_DAILY_COMMISSION_REQUEST });

    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const { data } = await axios.delete(`${baseUrl}/daily-commissions/${id}`, {
      headers: { Authorization: `Bearer ${adminInfo.token}` },
    });

    dispatch({ type: DELETE_DAILY_COMMISSION_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: DELETE_DAILY_COMMISSION_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to delete rake",
    });
  }
};

/**
 * GET COMMISSION SUMMARY
 */
export const getCommissionSummary =
  (filters = {}) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_COMMISSION_SUMMARY_REQUEST });

      const {
        adminLogin: { userInfo: adminInfo },
      } = getState();

      const { data } = await axios.get(`${baseUrl}/daily-commissions/summary`, {
        headers: { Authorization: `Bearer ${adminInfo.token}` },
        params: filters,
      });

      dispatch({
        type: GET_COMMISSION_SUMMARY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_COMMISSION_SUMMARY_FAIL,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch summary",
      });
    }
  };

/**
 * UPDATE EVIDENCE STATUS
 */
export const updateEvidenceStatus =
  (id, evidenceStatus, remarks = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_EVIDENCE_STATUS_REQUEST });

      const {
        adminLogin: { userInfo: adminInfo },
      } = getState();

      const { data } = await axios.put(
        `${baseUrl}/daily-commissions/${id}/status`,
        { evidenceStatus, remarks },
        {
          headers: {
            Authorization: `Bearer ${adminInfo.token}`,
            "Content-Type": "application/json",
          },
        },
      );

      dispatch({
        type: UPDATE_EVIDENCE_STATUS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_EVIDENCE_STATUS_FAIL,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Failed to update evidence status",
      });
    }
  };

/**
 * BULK UPDATE EVIDENCE STATUS
 */
export const bulkUpdateEvidenceStatus =
  (ids, evidenceStatus, remarks = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: BULK_UPDATE_EVIDENCE_STATUS_REQUEST });

      const {
        adminLogin: { userInfo: adminInfo },
      } = getState();

      const { data } = await axios.put(
        `${baseUrl}/daily-commissions/bulk-status`,
        { ids, evidenceStatus, remarks },
        {
          headers: {
            Authorization: `Bearer ${adminInfo.token}`,
            "Content-Type": "application/json",
          },
        },
      );

      dispatch({
        type: BULK_UPDATE_EVIDENCE_STATUS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: BULK_UPDATE_EVIDENCE_STATUS_FAIL,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Bulk update failed",
      });
    }
  };

/**
 * GET CLUBS AVAILABLE FOR RAKE ENTRY
 */
export const getRakeClubs = () => async (dispatch, getState) => {
  try {
    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const { data } = await axios.get(`${baseUrl}/daily-commissions/clubs`, {
      headers: {
        Authorization: `Bearer ${adminInfo.token}`,
      },
    });

    return data?.data?.clubs || [];
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch clubs for rake entry";
    throw new Error(message);
  }
};

/**
 * GET DEALERS BY CLUB (for dropdown in Add Rake modal)
 */
export const getDealersByClub = (clubIds) => async (dispatch, getState) => {
  try {
    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${adminInfo.token}`,
      },
      params: { clubIds: clubIds.join(",") },
    };

    const { data } = await axios.get(
      `${baseUrl}/daily-commissions/dealers`,
      config,
    );

    return data.dealers || [];
  } catch (error) {
    console.error("Error fetching dealers:", error);
    return [];
  }
};

/**
 * GET ALL STAFF BY CLUB (for coordinator dropdown in Add Rake modal)
 * Returns all staff members assigned to clubs, not just dealers
 */
export const getStaffByClub = (clubIds) => async (dispatch, getState) => {
  try {
    const {
      adminLogin: { userInfo: adminInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${adminInfo.token}`,
      },
      params: { clubIds: clubIds.join(",") },
    };

    const { data } = await axios.get(
      `${baseUrl}/daily-commissions/staff`,
      config,
    );

    return data.staff || [];
  } catch (error) {
    console.error("Error fetching staff:", error);
    return [];
  }
};

/**
 * EXPORT DAILY COMMISSIONS (CSV)
 */
export const exportDailyCommissions =
  (filters = {}) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: EXPORT_DAILY_COMMISSIONS_REQUEST });

      const {
        adminLogin: { userInfo: adminInfo },
      } = getState();

      const response = await axios.get(`${baseUrl}/daily-commissions/export`, {
        headers: { Authorization: `Bearer ${adminInfo.token}` },
        params: filters,
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `rake_records_${new Date().toISOString().split("T")[0]}.csv`,
      );
      document.body.appendChild(link);
      link.click();
      link.remove();

      dispatch({ type: EXPORT_DAILY_COMMISSIONS_SUCCESS });
    } catch (error) {
      dispatch({
        type: EXPORT_DAILY_COMMISSIONS_FAIL,
        payload:
          error.response?.data?.message || error.message || "Export failed",
      });
    }
  };
